import React from 'react';
import { getScreenName } from '../../../Utils/helper';
import {
  AccordianTabs,
  HeadingTagCategory,
  HeadingTagSubCategory,
} from '../GeneralItemsCategoryPage/styled';
import FaqsComponent from './Faqs';
import { FaqsOuter } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

function CategoryPageFaqsData(props) {
  const { faqsData, hideHeading, productData, resultPage } = props;

  const handleStateChangeCollapsable = (height, questionName, index) => {
    if (productData) {
      const catName =
        height === 0 ? 'expanded_pdp_widget' : 'collapsed_pdp_widget';
      fireEvent({
        category: catName,
        page_url: window.location.href,
        id: productData?.id,
        screen_name: getScreenName(),
        // pdp_variant: "aplus",
        selling_price: productData?.price,
        sku_nickname: productData?.nickname,
        sku_type: productData?.type,
        name: questionName,
        position: index,
        section_name: 'Faqs Section',
      });
    }
  };

  return (
    <FaqsOuter hideHeading={hideHeading}>
      {!hideHeading ? (
        <>
          <HeadingTagCategory>Frequently asked questions</HeadingTagCategory>
          <HeadingTagSubCategory>
            Expert-Provided Insights for Clarity and Confidence
          </HeadingTagSubCategory>
        </>
      ) : null}
      <AccordianTabs hideHeading={hideHeading}>
        {faqsData?.map((question, index) => {
          return (
            <FaqsComponent
              resultPage={resultPage}
              question={question}
              handleStateChangeCollapsable={handleStateChangeCollapsable}
              index={index}
              key={index}
            />
          );
        })}
      </AccordianTabs>
    </FaqsOuter>
  );
}

export default CategoryPageFaqsData;
